import { attr } from '@ember-data/model';
import ShModel from 'sh-www/models/sh-model';

// Keep aligned to UserActionItem.php file
export const BUYER_ACTION_TYPES = {
  OVERDUE_INVOICE: 'overdue_invoice',
  APPLICATION_AUTOCOMPLETING: 'application_autocompleting',
  POSTING_APPLICATIONS_EXPIRING: 'posting_applications_expiring',
  APPLICATION_PENDING_COMPLETION: 'application_pending_completion',
  ADVANCE_REQUEST: 'advance_request',
  POSTING_DEADLINE: 'posting_deadline',
  INVOICE_DUE: 'invoice_due',
  COUNTER_OFFER: 'counter_offer',
  POSTING_APPLICATION_REVIEW: 'application_review',
};

// Keep aligned to UserActionItem.php file
export const SELLER_ACTION_TYPES = {
  RECENT_PAYOUT_FAILED: 'recent_payout_failed',
  PROJECT_AUTOCOMPLETES_TODAY: 'project_autocompletes_today',
  UPCOMING_PAYOUT_CANNOT_BE_PROCESSED: 'upcoming_payout_cannot_be_processed',
  PROJECT_AUTOCOMPLETES_TOMORROW: 'project_autocompletes_tomorrow',
  PROJECT_CONFIRM_COMPLETION: 'project_confirm_completion',
  PROJECT_ACCEPT_ADVANCE: 'project_accept_advance',
  APPLICATION_SIGN_CONTRACT: 'application_sign_contract',
  PROJECT_SIGN_CONTRACT: 'project_sign_contract',
  APPLICATION_REVIEW_OFFER: 'application_review_offer',
  PROJECT_REVIEW_OFFER: 'project_review_offer',
  POSTING_LAST_DAY: 'posting_last_day',
  APPLICATION_SAVED_DEADLINE: 'application_saved_deadline',
  APPLICATION_INVITED_DEADLINE: 'application_invited_deadline',
};

class UserActionItem extends ShModel {
  @attr('string') title;
  @attr('string') subtextName;
  @attr('string') reason;
  @attr('string') type;
  @attr('string') associatedModelName;
  @attr('number') priority;
  @attr('string') path;
  @attr('number') daysUntilDelinquent;
}

export default UserActionItem;
